module.exports = {"pathContext":{"name":"MonthlyDueDateType","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":"Due date is the end of the month","isDeprecated":false,"name":"END_OF_MONTH"},{"deprecationReason":null,"description":"Due date is a specific day of the month","isDeprecated":false,"name":"SPECIFIC_DAY"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-monthly-due-date-type.json
// module id = 1264
// module chunks = 224648358069685